// Checkout ticket info component
import styles from '../css/checkOutScreen.module.css';
import { useRef, useEffect } from 'react';

export default function CheckOutTicketInfo({ findTkt, ticket, setTicket, locator }) {
  // const navigate = useNavigate();
  // Ticket input and find ticket button

  const ticketInputRef = useRef();

  useEffect(() => {
    if (ticketInputRef.current) {
      ticketInputRef.current.focus();
    }
  }, []);

  return (
    <div className={styles.headerDiv}>
      <label htmlFor="ticket" className={styles.inputLabel}>
        Ticket Number:
      </label>
      <input
        ref={ticketInputRef}
        className={styles.ticketInput}
        type="text"
        onChange={(e) => {
          setTicket(e.target.value);
        }}
        value={ticket || locator || ''}
        onBlur={() => {
          findTkt();
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter') {
            findTkt();
          }
        }}
        placeholder="Ticket or Locator Number"
      />
      <button
        className={styles.findTicketBtn}
        type="button"
        onClick={() => {
          findTkt();
        }}
      >
        Find Ticket
      </button>
    </div>
  );
}
